import { Checkbox, FormControlLabel, FormHelperText, Grid, InputLabel } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import React, { useContext, useEffect, useState } from 'react';
import { MultiselectWithoutCheckbox, SecondaryButton, SelectBox } from '../../../../Core/FormInput';
import { MandatoryField, SimpleField } from '../../../../Core/FormInput/inputfields';
import { getSalesDriver_ScreenDropdown, getSalesDriverByID, postSalesDriver } from '../../../../Core/Service/wipSales-Services/driverRateSales-service';
import AppContext from '../../../../App/AppContext';

const AddSalesDriver = ({ fromScreen, selectedDriverID = null, onClose }) => {
    const { showToast } = useContext(AppContext);

    const isAgency = fromScreen === 'driveragency';

    const [form, setForm] = useState({
        deliveryResourceId: null,
        deliveryResourceName: '',
        deliveryResourcePhone: '',
        deliveryResourceEmail: '',
        password: '',
        confirmPassword: '',
        deliveryResourceMinimumRate: '',
        deliveryResourceMilesIncluded: '',
        deliveryResourceMilesRate: '',
        deliveryResourceBranchId: '',
        deliveryResourceWebsite: '',
        deliveryResourcePostCode: '',
        deliveryResourceAddressLine1: '',
        deliveryResourceAddressLine2: '',
        deliveryResourceTown: '',
        deliveryResourceCounty: '',
        deliveryResourceCountry: '',
        deliveryResourceIsWorking: false,
        dtLicenseType: []
    });

    const [dropdown, setDropdown] = useState({
        branchList: [],
        licenseTypeList: []
    });

    const [state, setState] = useState({
        licenseGroups: []
    });

    const [errors, setErrors] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    // GET EDIT DATA
    useEffect(() => {
        if (!selectedDriverID) return;

        const loadData = async () => {
            try {
                setIsLoading(true);

                let res = await getSalesDriverByID(selectedDriverID);

                if (res.success && res?.data?.details?.length > 0) {
                    let data = res.data.details[0];
                    let licenseList = res.data.dtLicenseType || [];

                    setForm({
                        deliveryResourceId: data.deliveryResourceID,
                        deliveryResourceName: data.deliveryResourceName || '',
                        deliveryResourcePhone: data.deliveryResourcePhone || '',
                        deliveryResourceEmail: data.deliveryResourceEmail || '',
                        password: '',
                        confirmPassword: '',
                        deliveryResourceMinimumRate: data.deliveryResourceMinimumRate || '',
                        deliveryResourceMilesIncluded: data.deliveryResourceMilesIncluded || '',
                        deliveryResourceMilesRate: data.deliveryResourceMilesRate || '',
                        deliveryResourceBranchId: data.deliveryResourceBranchID || '',
                        deliveryResourceIsWorking: data.deliveryResourceIsWorking || false,
                        deliveryResourceWebsite: data.deliveryResourceWebsite || '',
                        deliveryResourcePostCode: data.deliveryResourcePostCode || '',
                        deliveryResourceAddressLine1: data.deliveryResourceAddressLine1 || '',
                        deliveryResourceAddressLine2: data.deliveryResourceAddressLine2 || '',
                        deliveryResourceTown: data.deliveryResourceTown || '',
                        deliveryResourceCounty: data.deliveryResourceCounty || '',
                        deliveryResourceCountry: data.deliveryResourceCountry || '',
                        dtLicenseType: licenseList.map((x) => x.id)
                    });
                }
            } catch (error) {
                console.error('Edit Load Error:', error);
                showToast('Failed to load driver details.', 'error');
            } finally {
                setIsLoading(false);
            }
        };

        loadData();
    }, [selectedDriverID]);

    // GET DROPDOWNS
    useEffect(() => {
        const fetchDropdown = async () => {
            try {
                setIsLoading(true);

                let res = await getSalesDriver_ScreenDropdown();
                if (res.success) {
                    setDropdown({
                        branchList: res.data.list.table1 || [],
                        licenseTypeList: res.data.list.table || []
                    });
                }
            } catch (error) {
                console.error('Dropdown Error:', error);
                showToast('Failed to load dropdown data.', 'error');
            } finally {
                setIsLoading(false);
            }
        };

        fetchDropdown();
    }, []);

    // License restore if editing
    useEffect(() => {
        if (form.dtLicenseType && dropdown.licenseTypeList.length > 0) {
            setState({
                licenseGroups: dropdown.licenseTypeList.filter((i) => form.dtLicenseType.includes(i.id))
            });
        }
    }, [form.dtLicenseType, dropdown.licenseTypeList]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleLicenseSelect = (e, values) => {
        setState({ licenseGroups: values });
        setForm((prev) => ({
            ...prev,
            dtLicenseType: values.map((i) => i.id)
        }));
    };

    const handleCheckbox = (event) => {
        const { name, checked } = event.target;
        setForm((st) => ({ ...st, [name]: checked }));
    };

    const validate = () => {
        let err = {};
        if (!form.deliveryResourceName) err.deliveryResourceName = 'Full Name is required';
        if (!form.deliveryResourceEmail) err.deliveryResourceEmail = 'Email is required';

        if (!form.deliveryResourceId) {
            if (!form.password) err.password = 'Password is required';
            if (form.password !== form.confirmPassword) err.confirmPassword = 'Password mismatch';
        }

        if (!form.deliveryResourceMinimumRate) err.deliveryResourceMinimumRate = 'Required';
        if (!form.deliveryResourceMilesRate) err.deliveryResourceMilesRate = 'Required';

        // if (!isAgency && !form.deliveryResourceBranchId) err.deliveryResourceBranchId = 'Required';

        if (!isAgency && !state.licenseGroups.length) err.dtLicenseType = 'Required';

        setErrors(err);
        return Object.keys(err).length === 0;
    };

    const handleSubmit = async () => {
        if (!validate()) return;

        const payload = {
            deliveryResourceId: form.deliveryResourceId,
            password: form.password,
            deliveryResourceName: form.deliveryResourceName,
            deliveryResourceAddressLine1: isAgency ? form.deliveryResourceAddressLine1 : null,
            deliveryResourceAddressLine2: isAgency ? form.deliveryResourceAddressLine2 : null,
            deliveryResourceTown: isAgency ? form.deliveryResourceTown : null,
            deliveryResourceCounty: isAgency ? form.deliveryResourceCounty : null,
            deliveryResourcePostCode: isAgency ? form.deliveryResourcePostCode : null,
            deliveryResourceCountry: isAgency ? form.deliveryResourceCountry : null,
            deliveryResourcePhone: form.deliveryResourcePhone || null,
            deliveryResourceFax: null,
            deliveryResourceEmail: form.deliveryResourceEmail,
            deliveryResourceWebsite: isAgency ? form.deliveryResourceWebsite : null,
            deliveryResourceMinimumRate: Number(form.deliveryResourceMinimumRate),
            deliveryResourceMilesIncluded: Number(form.deliveryResourceMilesIncluded) || null,
            deliveryResourceBranchcode: isAgency ? null : form.deliveryResourceBranchId,
            deliveryResourceMilesRate: Number(form.deliveryResourceMilesRate),
            deliveryResourceRateUpdatedUser: null,
            deliveryResourcePortalUserID: null,
            deliveryResourceInternal: isAgency ? false : true,
            deliveryResourceIsWorking: form.deliveryResourceIsWorking || false,
            dtLicenseType: isAgency ? [] : state.licenseGroups.map((x) => x.id),
            userType: isAgency ? 'driveragency' : 'driver'
        };

        console.log('Payload:', payload);

        setIsSubmitting(true);

        try {
            let res = await postSalesDriver(payload);
            if (res?.success) {
                showToast(res.message || 'Saved Successfully!');
                onClose?.(true);
            } else {
                showToast(res?.message || 'Save failed!', 'error');
            }
        } catch (error) {
            console.error('Save Error:', error);
            showToast('Something went wrong while saving!', 'error');
        } finally {
            setIsSubmitting(false);
        }
    };

    // FULL SCREEN LOADER BLOCK
    if (isLoading) {
        return (
            <Grid container justify="center" alignItems="center" style={{ height: '240px' }}>
                <CircularProgress />
            </Grid>
        );
    }

    return (
        <Grid container spacing={2}>
            {/* Full Name & Phone */}
            <Grid item xs={12} sm={6}>
                <MandatoryField
                    name="deliveryResourceName"
                    inputLabel="Full Name"
                    value={form.deliveryResourceName}
                    onChange={handleChange}
                    error={!!errors.deliveryResourceName}
                    helperText={errors.deliveryResourceName}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <SimpleField name="deliveryResourcePhone" inputLabel="Phone Number" value={form.deliveryResourcePhone} onChange={handleChange} />
            </Grid>

            {/* Email + IsWorking */}
            <Grid item xs={12}>
                <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm>
                        <MandatoryField
                            name="deliveryResourceEmail"
                            inputLabel="Email"
                            value={form.deliveryResourceEmail}
                            onChange={handleChange}
                            error={!!errors.deliveryResourceEmail}
                            helperText={errors.deliveryResourceEmail}
                        />
                    </Grid>
                    {form.deliveryResourceId && !isAgency && (
                        <Grid item xs="auto">
                            <FormControlLabel
                                control={<Checkbox checked={form.deliveryResourceIsWorking} name="deliveryResourceIsWorking" onChange={handleCheckbox} />}
                                label="Is Working?"
                            />
                        </Grid>
                    )}
                </Grid>
            </Grid>

            {/* Password - Only Add Mode */}
            {!form.deliveryResourceId && (
                <>
                    <Grid item xs={12} sm={6}>
                        <MandatoryField
                            name="password"
                            inputLabel="Password"
                            type="password"
                            value={form.password}
                            onChange={handleChange}
                            error={!!errors.password}
                            helperText={errors.password}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <MandatoryField
                            name="confirmPassword"
                            inputLabel="Confirm password"
                            type="password"
                            value={form.confirmPassword}
                            onChange={handleChange}
                            error={!!errors.confirmPassword}
                            helperText={errors.confirmPassword}
                        />
                    </Grid>
                </>
            )}

            {/* Rates */}
            <Grid item xs={12} sm={6}>
                <SimpleField
                    name="deliveryResourceMinimumRate"
                    inputLabel="Min Rate"
                    type="number"
                    value={form.deliveryResourceMinimumRate}
                    onChange={handleChange}
                    error={!!errors.deliveryResourceMinimumRate}
                    helperText={errors.deliveryResourceMinimumRate}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <SimpleField
                    name="deliveryResourceMilesIncluded"
                    inputLabel="Miles Included"
                    type="number"
                    value={form.deliveryResourceMilesIncluded}
                    onChange={handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <SimpleField
                    name="deliveryResourceMilesRate"
                    inputLabel="Miles Rate"
                    type="number"
                    value={form.deliveryResourceMilesRate}
                    onChange={handleChange}
                    error={!!errors.deliveryResourceMilesRate}
                    helperText={errors.deliveryResourceMilesRate}
                />
            </Grid>

            {/* Driver-only Fields */}
            {!isAgency && (
                <>
                    <Grid item xs={12} sm={6}>
                        <InputLabel shrink>Branch</InputLabel>
                        <SelectBox name="deliveryResourceBranchId" value={form.deliveryResourceBranchId} onChange={handleChange} List={dropdown.branchList} />
                        <FormHelperText error>{errors.deliveryResourceBranchId}</FormHelperText>
                    </Grid>

                    <Grid item xs={12}>
                        <InputLabel shrink>License Type</InputLabel>
                        <MultiselectWithoutCheckbox options={dropdown.licenseTypeList} value={state.licenseGroups} onChange={handleLicenseSelect} />
                        <FormHelperText error>{errors.dtLicenseType}</FormHelperText>
                    </Grid>
                </>
            )}

            {/* Agency-only Fields */}
            {isAgency && (
                <>
                    <Grid item xs={12} sm={6}>
                        <SimpleField name="deliveryResourceWebsite" inputLabel="Website" value={form.deliveryResourceWebsite} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SimpleField name="deliveryResourcePostCode" inputLabel="Post Code" value={form.deliveryResourcePostCode} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SimpleField name="deliveryResourceCountry" inputLabel="Country" value={form.deliveryResourceCountry} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SimpleField
                            name="deliveryResourceAddressLine1"
                            inputLabel="Address Line 1"
                            value={form.deliveryResourceAddressLine1}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SimpleField
                            name="deliveryResourceAddressLine2"
                            inputLabel="Address Line 2"
                            value={form.deliveryResourceAddressLine2}
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SimpleField name="deliveryResourceTown" inputLabel="Town" value={form.deliveryResourceTown} onChange={handleChange} />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <SimpleField name="deliveryResourceCounty" inputLabel="County" value={form.deliveryResourceCounty} onChange={handleChange} />
                    </Grid>
                </>
            )}

            <Grid item xs={12}>
                <SecondaryButton fullWidth onClick={handleSubmit} isBtnLoader={isSubmitting}>
                    Save
                </SecondaryButton>
            </Grid>
        </Grid>
    );
};

export default AddSalesDriver;
